import { jwtDecode } from "jwt-decode";
import {
  DATABASE_CLIENT_PAGE,
  DATABASE_VEHICULE_PAGE,
  FERRAILLEURS_ENCHERES_VISIBLES_PAGE,
  MODULE_SELECTOR_PAGE,
  VHU_LOTS_PAGE,
} from "../routes/routeConstants";

export const ROLES = {
  ADMIN: "ROLE_ADMIN",
  AGENT: "ROLE_AGENT",
  EXPERT: "ROLE_EXPERT",
  ASSURANCE: "ROLE_ASSURANCE",
  FERRAILLEUR: "ROLE_FERRAILLEUR",
};

export const EXPERIENCE = {
  EXPERT: "expert",
  ASSURANCE: "assurance",
  FERRAILLEUR: "ferrailleur",
};

export const EXPERT_ROLES = [ROLES.ADMIN, ROLES.AGENT, ROLES.EXPERT];
export const ASSURANCE_ROLES = [ROLES.ASSURANCE];
export const FERRAILLEUR_ROLES = [ROLES.FERRAILLEUR];

export function normalizeRoles(value) {
  if (typeof value === "string") {
    return normalizeRoles(value.split(","));
  }
  if (!Array.isArray(value)) {
    return [];
  }
  return value
    .map((role) => (typeof role === "string" ? role.trim() : ""))
    .filter(Boolean)
    .map((role) => (role.startsWith("ROLE_") ? role : `ROLE_${role}`))
    .map((role) => role.toUpperCase());
}

export function getAuthUser() {
  try {
    return JSON.parse(localStorage.getItem("authUser") || "null");
  } catch (error) {
    console.error("Error parsing authUser from localStorage", error);
    return null;
  }
}

export function getCurrentRoles() {
  const authUser = getAuthUser();
  const token = authUser?.accessToken;
  if (!token) {
    return [];
  }
  try {
    const payload = jwtDecode(token);
    return normalizeRoles(payload.roles || payload.authorities || []);
  } catch (error) {
    console.error("Error decoding auth roles", error);
    return [];
  }
}

export function hasAnyRole(userRoles, allowedRoles = []) {
  if (!allowedRoles || allowedRoles.length === 0) {
    return true;
  }
  const roles = new Set(normalizeRoles(userRoles));
  return normalizeRoles(allowedRoles).some((role) => roles.has(role));
}

export function getPrimaryExperience(userRoles = getCurrentRoles()) {
  if (hasAnyRole(userRoles, EXPERT_ROLES)) {
    return EXPERIENCE.EXPERT;
  }
  if (hasAnyRole(userRoles, ASSURANCE_ROLES)) {
    return EXPERIENCE.ASSURANCE;
  }
  if (hasAnyRole(userRoles, FERRAILLEUR_ROLES)) {
    return EXPERIENCE.FERRAILLEUR;
  }
  return EXPERIENCE.EXPERT;
}

export function getDefaultRouteForRoles(userRoles = getCurrentRoles()) {
  switch (getPrimaryExperience(userRoles)) {
    case EXPERIENCE.ASSURANCE:
      return DATABASE_VEHICULE_PAGE;
    case EXPERIENCE.FERRAILLEUR:
      return FERRAILLEURS_ENCHERES_VISIBLES_PAGE;
    case EXPERIENCE.EXPERT:
      return MODULE_SELECTOR_PAGE;
    default:
      return VHU_LOTS_PAGE;
  }
}

